var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 108,
    viewBox: "0 0 70 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5924 71.1375C55.6129 72.5169 55.6276 73.8962 55.6388 75.2757C55.6447 75.8685 55.6527 76.4612 55.6631 77.054C55.7604 82.7632 55.1473 88.2838 50.4806 90.9504C49.0592 92.0858 44.3028 93.399 42.4806 93.6171C42.3705 94.3538 42.5929 93.5322 42.4806 94.2838C41.5126 98.4757 42.5108 102.447 38.969 104.771C36.0854 106.477 34.1033 106.722 30.6666 106.722C30.6666 96.6747 30.6666 86.6271 30.6666 76.275C30.6666 76.275 55.5517 68.7403 55.5924 71.1375Z",
    fill: "#004F81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1472 72.6754V93.3421C42.4806 98.6754 42.5108 102.838 38.969 105.162C36.0854 106.869 34.1033 107.114 30.6666 107.114C30.6666 97.0664 30.6666 87.0187 30.6666 76.6666L43.1472 72.6754Z",
    fill: "#258CCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 0L47.3333 0.666667C54.6666 10.6667 58.6666 28 56.6666 37.3333C55.0666 44.8 38.2222 52.4444 32.6666 58C37.6393 47.7231 40.5239 36.7868 42.1401 26.6667C42.1401 16 42 6.66667 42.6666 0Z",
    fill: "#FFBB01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.225 26.3953L42.6667 14C39.2625 13.9075 31.5193 15.8953 28.225 17.7286C30.5062 23.3285 38.9882 26.1151 42.225 26.3953Z",
    fill: "#707070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 0.666626C70.6579 34.4584 25.7655 67.1909 0 78.9998C55.5992 96.032 70 64.6104 70 40C70 20.4708 56.3739 5.88981 47.3333 0.666626Z",
    fill: "url(#paint0_linear_29_4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7513 3.09677C21.658 9.66042 23.7742 17.8065 25.6129 24C31.1291 17.0323 37.5591 15.6989 42.6667 14.6667L42.7742 0H41.7836C37.4933 0 35.0416 0 30.7513 3.09677Z",
    fill: "#868686"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_4",
    x1: 62,
    y1: -1.33338,
    x2: 6.66667,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258CCD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAira);
export default __webpack_public_path__ + "static/media/aira.3b87dcb79ac62fc87dfeb2cd696f6303.svg";
export { ForwardRef as ReactComponent };